export default __webpack_public_path__ + "static/media/waste-garbage-trucks.dbe32a6c.jpg";